import type { ReactNode } from 'react';
import './StatsRow.css';

export type StatsItem = {
  label: string;
  value: ReactNode;
  tone?: 'primary' | 'accent' | 'neutral';
};

export type StatsRowProps = {
  items: StatsItem[];
  className?: string;
};

export const StatsRow = ({ items, className }: StatsRowProps) => {
  return (
    <div className={['stats-row', className].filter(Boolean).join(' ')}>
      {items.map((item) => (
        <div
          key={item.label}
          className={['stats-card', item.tone ? `stats-card--${item.tone}` : null]
            .filter(Boolean)
            .join(' ')}
        >
          <div className="stats-card__value">{item.value}</div>
          <div className="stats-card__label">{item.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StatsRow;
